import { QueryCache, QueryClient, QueryClientProvider, QueryMeta } from '@tanstack/react-query';
import * as React from 'react';
import { toast } from 'sonner';
import { EventLogger, IEventArgs } from '../extViewmodels';

export interface LevStandardQueryMeta extends QueryMeta {
	toastErrorMessage?: string | ((error: Error) => string);
	errorLogging?: IEventArgs;
}

export const reactQueryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			if (!query.meta) {
				return;
			}
			const meta = query.meta as LevStandardQueryMeta;
			if (meta.toastErrorMessage) {
				const message =
					typeof meta.toastErrorMessage === 'function' ? meta.toastErrorMessage(error) : meta.toastErrorMessage;
				// A function-form message may return an empty string to suppress the toast for
				// errors the UI handles inline (e.g. an expected 404 rendered as an empty state).
				if (message) {
					toast.error(message);
				}
			}
			if (meta.errorLogging) {
				EventLogger.logEvent(meta.errorLogging, {
					error,
				});
			}
		},
	}),
});
export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
	return <QueryClientProvider client={reactQueryClient}>{children}</QueryClientProvider>;
}
